import { Component, OnInit, OnDestroy } from '@angular/core';
import { MeServiceService } from 'src/app/shared/services/me-service.service';
import { MeServiceDto } from 'src/app/shared/classes/me-service-dto';
import { MeServicesSlider } from 'src/app/shared/data/slider';
import { WhyChooseUsDto } from 'src/app/shared/classes/why-choose-us-dto';
import { WhyChooseUsService } from 'src/app/shared/services/why-choose-us.service';

@Component({
  selector: 'app-fashion-one',
  templateUrl: './fashion-one.component.html',
  styleUrls: ['./fashion-one.component.scss']
})
export class FashionOneComponent implements OnInit {

  public textServices:string = 'At DsAlpha, we offer a wide range of specialized software services designed to transform your technological vision into reality. From expert consultancy to innovative architecture, from frontend development to backend solutions, and from database design to DevOps configurations, we provide comprehensive solutions tailored to meet your unique business needs. Partner with us for industry-leading quality, innovation, and sustainable software solutions.';
  public meServices : MeServiceDto[] = [];
  public whyChooseUs : WhyChooseUsDto[] = [];
  active

  constructor(
    private meServiceService: MeServiceService,
    private whyChooseUsService: WhyChooseUsService
    ) {
    this.meServiceService.getMeServices.subscribe(response => {
      this.meServices = response;
    });
    this.whyChooseUsService.getWhyChooseUs.subscribe(response => {
      this.whyChooseUs = response;
    });
  
  }

  public MeServiceSliderConfig: any = MeServicesSlider;

  public sliders = [{
    title: 'welcome to DsAlpha',
    subTitle: 'Consulting Services',
    image: 'assets/images/services/consultingServices/portada.svg'
  }, {
    title: 'welcome to DsAlpha',
    subTitle: 'Software Architecture Design',
    image: 'assets/images/services/softwareArchitectureDesign/portada.svg'
  }, {
    title: 'welcome to DsAlpha',
    subTitle: 'Frontend Development',
    image: 'assets/images/services/frontendDevelopment/portada.svg'
  }, {
    title: 'welcome to DsAlpha',
    subTitle: 'Backend Development',
    image: 'assets/images/services/backendDevelopment/portada.svg'
  }, {
    title: 'welcome to DsAlpha',
    subTitle: 'Utility NuGet Package Creation',
    image: 'assets/images/services/utilityNuGetPackageCreation/portada.svg'
  }, {
    title: 'welcome to DsAlpha',
    subTitle: 'Functionality Repair & Optimization',
    image: 'assets/images/services/functionalityRepairOptimization/portada.svg'
  }, {
    title: 'welcome to DsAlpha',
    subTitle: 'Custom Software Extensions',
    image: 'assets/images/services/customSoftwareExtensions/portada.svg'
  }, {
    title: 'welcome to DsAlpha',
    subTitle: 'Database Design and Implementation',
    image: 'assets/images/services/databaseDesignImplementation/portada.svg'
  }, {
    title: 'welcome to DsAlpha',
    subTitle: 'DevOps Configuration',
    image: 'assets/images/services/devOpsConfiguration/portada.svg'
  }, {
    title: 'welcome to DsAlpha',
    subTitle: 'Solutions Architecture',
    image: 'assets/images/services/solutionsArchitecture/portada.svg'
  }, {
    title: 'welcome to DsAlpha',
    subTitle: 'Microservices Solutions',
    image: 'assets/images/services/microservicesSolutions/portada.svg'
  }, {
    title: 'welcome to DsAlpha',
    subTitle: 'Server Configuration & Management',
    image: 'assets/images/services/serverConfigurationManagement/portada.svg'
  }];

  ngOnInit(): void {
  }

  
}
